"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Regex = void 0;
exports.Regex = {
    STREET_NAME: /^[a-zA-Z0-9()\- ]+$/,
};
//# sourceMappingURL=regex.js.map